import {
  GET_BOARD_REPORTS_REQUEST,
  GET_BOARD_REPORTS_SUCCESS,
  GET_BOARD_REPORTS_FAIL,
  GET_BOARD_MINI_SUMMARY_REQUEST,
  GET_BOARD_MINI_SUMMARY_SUCCESS,
  GET_BOARD_MINI_SUMMARY_FAIL,
  GET_BOARD_MEMBER_WORKLOAD_REQUEST,
  GET_BOARD_MEMBER_WORKLOAD_SUCCESS,
  GET_BOARD_MEMBER_WORKLOAD_FAIL,
  GET_BOARD_MEMBER_WORKLOAD_WEEKLY_REQUEST,
  GET_BOARD_MEMBER_WORKLOAD_WEEKLY_SUCCESS,
  GET_BOARD_MEMBER_WORKLOAD_WEEKLY_FAIL,
} from "./summaryTypes";

const initialState = {
  // Board Reports
  reports: {
    chartData: null,
    TasksData: null,
    loading: false,
    error: null,
  },
  // Member workload
  memberWorkload: {
    data: [],
    loading: false,
    error: null,
  },
  memberWorkloadWeekly: {
    data: {
      lastWeek: { rows: [], dayKeys: [] },
      thisWeek: { rows: [], dayKeys: [] },
    },
    loading: false,
    error: null,
  },
  // Mini Summary (last 7 days)
  miniSummary: {
    // Tasks stats (last 7 days)
    tasksCompletedLast7Days: 0,
    tasksCreatedLast7Days: 0,
    subTasksCompletedLast7Days: 0,
    subTasksCreatedLast7Days: 0,
    tasksStartedLast7Days: 0,
    tasksOverdueNotCompletedLast7Days: 0,
    subTasksStartedLast7Days: 0,
    subTasksOverdueNotCompletedLast7Days: 0,
    // Sprint stats
    sprintNotArchived: 0,
    sprintArchived: 0,
    sprintOverdueNotCompleted: 0,
    sprintCreatedLast7Days: 0,
    sprintCompletedLast7Days: 0,
    sprintOverdueNotCompletedLast7Days: 0,
    // Overall stats
    tasksOverdueNotCompletedTotal: 0,
    subTasksOverdueNotCompletedTotal: 0,
    totalTasksNotArchived: 0,
    totalTasksArchived: 0,
    totalBacklogNotArchived: 0,
    totalTasksCompleted: 0,
    totalSubTasksCompleted: 0,
    kanbanCrmTradesCount: 0,
    kanbanRegularTasksCount: 0,
    kanbanBoardByColumn: [],
    // History
    BoardHistories: [],
    loading: false,
    error: null,
  },
};

export const summaryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Board Reports
    case GET_BOARD_REPORTS_REQUEST:
      return {
        ...state,
        reports: {
          ...state.reports,
          loading: true,
          error: null,
        },
      };

    case GET_BOARD_REPORTS_SUCCESS:
      return {
        ...state,
        reports: {
          ...state.reports,
          chartData: action.payload.chartData,
          TasksData: action.payload.TasksData,
          loading: false,
          error: null,
        },
      };

    case GET_BOARD_REPORTS_FAIL:
      return {
        ...state,
        reports: {
          ...state.reports,
          loading: false,
          error: action.payload,
        },
      };

    // Mini Summary
    case GET_BOARD_MINI_SUMMARY_REQUEST:
      return {
        ...state,
        miniSummary: {
          ...state.miniSummary,
          loading: true,
          error: null,
        },
      };

    case GET_BOARD_MINI_SUMMARY_SUCCESS:
      return {
        ...state,
        miniSummary: {
          ...state.miniSummary,
          ...action.payload,
          loading: false,
          error: null,
        },
      };

    case GET_BOARD_MINI_SUMMARY_FAIL:
      return {
        ...state,
        miniSummary: {
          ...state.miniSummary,
          loading: false,
          error: action.payload,
        },
      };

    // Member workload
    case GET_BOARD_MEMBER_WORKLOAD_REQUEST:
      return {
        ...state,
        memberWorkload: {
          ...state.memberWorkload,
          loading: true,
          error: null,
        },
      };

    case GET_BOARD_MEMBER_WORKLOAD_SUCCESS:
      return {
        ...state,
        memberWorkload: {
          ...state.memberWorkload,
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case GET_BOARD_MEMBER_WORKLOAD_FAIL:
      return {
        ...state,
        memberWorkload: {
          ...state.memberWorkload,
          loading: false,
          error: action.payload,
        },
      };

    // Weekly member workload
    case GET_BOARD_MEMBER_WORKLOAD_WEEKLY_REQUEST:
      return {
        ...state,
        memberWorkloadWeekly: {
          ...state.memberWorkloadWeekly,
          loading: true,
          error: null,
        },
      };

    case GET_BOARD_MEMBER_WORKLOAD_WEEKLY_SUCCESS:
      return {
        ...state,
        memberWorkloadWeekly: {
          ...state.memberWorkloadWeekly,
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case GET_BOARD_MEMBER_WORKLOAD_WEEKLY_FAIL:
      return {
        ...state,
        memberWorkloadWeekly: {
          ...state.memberWorkloadWeekly,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};
